/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I plot several lines?`)
};

const es_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo graficar varias líneas?`)
};

const de_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mehrere Linien darstellen?`)
};

const nl_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik meerdere lijnen plotten?`)
};

const fr_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je tracer plusieurs courbes ?`)
};

const it_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso tracciare più linee?`)
};

const pt_br2_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso plotar várias linhas?`)
};

const pt_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso representar várias linhas?`)
};

const ja_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の線をプロットできますか？`)
};

const zh_line_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以绘制多条线吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_q2", locale)
	if (locale === "en") return en_line_faq_q2(inputs)
	if (locale === "es") return es_line_faq_q2(inputs)
	if (locale === "de") return de_line_faq_q2(inputs)
	if (locale === "nl") return nl_line_faq_q2(inputs)
	if (locale === "fr") return fr_line_faq_q2(inputs)
	if (locale === "it") return it_line_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_q2(inputs)
	if (locale === "pt") return pt_line_faq_q2(inputs)
	if (locale === "ja") return ja_line_faq_q2(inputs)
	return zh_line_faq_q2(inputs)
};